export default class PointsOnMap {
  lats!: any[];
  lngs!: any[];
  ids!: any[];
}
